/** I18n locale used to format numbers, etc. */
export const locale = 'de-CH'
